import { Injectable } from '@angular/core'
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http'
import { Observable, from, throwError } from 'rxjs'
import { catchError, mergeMap } from 'rxjs/operators'
import { Router } from '@angular/router'
import { KeycloakService } from '../services/keycloak.service'
import { AuthService } from '../services/auth.service'

@Injectable()
export class KeycloakBearerInterceptor implements HttpInterceptor {
  constructor(
    private keycloakService: KeycloakService,
    private authService: AuthService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.keycloakService.isAuthenticated()) {
      return next.handle(req)
    }

    // Check if request is to allowed domain
    const isAllowedDomain = this.authService.tokenAllowedDomains.some(domain =>
      req.url.includes(domain)
    )

    if (!isAllowedDomain) {
      return next.handle(req)
    }

    // Update token if needed and add to request
    return from(this.keycloakService.updateToken(30)).pipe(
      mergeMap((refreshed) => {
        const token = this.keycloakService.getToken()
        if (token) {
          const authReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          })
          return next.handle(authReq).pipe(
            catchError((error: HttpErrorResponse) => {
              if (error.status === 401) {
                this.handleAuthError()
                return throwError(error)
              }
              return throwError(error)
            })
          )
        }

        return next.handle(req)
      }),
      catchError((error) => {
        console.error('Failed to refresh Keycloak token:', error)
        // Continue without token
        return next.handle(req)
      })
    )
  }

  private handleAuthError(): void {
    // Don't redirect if we're already on the login page
    if (!this.router.url.includes('/login')) {
      const currentPath = this.router.url.replace('/', '')
      this.router.navigate(['/login'], {
        queryParams: currentPath ? { redirectTo: currentPath } : {}
      })
    }
  }
}
